// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain, RedirectToHomePage } from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getHomePageUrl, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { getSettingsCollection } from "@west/App/Store/Selectors/SettingsSelectors";

export const RedirectToExternalLogout: typeof RedirectToHomePage = props => {
    const state = props.getState();
    const externalLogoutUrl = getSettingsCollection(state).customSettings.externalLogoutUrl;
    if(!externalLogoutUrl) return;
    window.location.href = externalLogoutUrl;
    return false;
};

export const RedirectToNextPage: typeof RedirectToHomePage = props => {
    if (!(props.parameter as { redirectTo?: string }).redirectTo) {
        return;
    }

    const redirectTo = (props.parameter as { redirectTo?: string }).redirectTo || "";

    const state = props.getState();
    const nextPage = getPageLinkByPageType(state, redirectTo)?.url;
    window.location.href = nextPage || getHomePageUrl(state);
    return false;
};

addToChainBefore(chain, RedirectToHomePage, RedirectToExternalLogout);
addToChainBefore(chain, RedirectToHomePage, RedirectToNextPage);
